export const QUERY_PARAMS = {
  COMPARED_MATCH: 'match',
  SUBFACTOR: 'subfactor',
  PREDICTION_FACTOR: 'factor',
}
